<div class="mbb-user-details-container" [formGroup]="form">
  <strong>Gi ruteren et navn</strong>
  <p>Et navn på ruteren gjør det enklere å finne den igjen på Min side og i ice-app'en.</p>

  <div class="mbb-user-details-form-group">
    <app-ice-input-field
      formControlName="routerName"
      label="Navn på ruter"
      labelHelpText="F.eks Hytta, Bilen osv."
      ngDefaultControl
      ngxsFormPath="formState.mbbForm"
      placeholder="Ruter sitt navn"
      textTestId="router-name-input"
      [errorText]="getRouterNameErrorText(form.controls.routerName.errors)"
      [maxLength]="50"
      [minlength]="3"
    />
  </div>
</div>
